import {EventBase} from "shared/utilities/Events/EventManager";
import {PropertyBase} from "../pagebuilder/Controls/Properties/PropertyBase";


export class UpdateProperties extends EventBase {
    ReturnType: void;

    constructor(public properties:PropertyBase[])
    {
        super();
    }

    public static GetName() {
        return 'OpenProperties';
    }
}